namespace RioERP.Masters {
    export namespace WhatsAppTemplateVariablesService {
        export const baseUrl = 'Masters/WhatsAppTemplateVariables';

        export declare function Create(request: Serenity.SaveRequest<WhatsAppTemplateVariablesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<WhatsAppTemplateVariablesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<WhatsAppTemplateVariablesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<WhatsAppTemplateVariablesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Masters/WhatsAppTemplateVariables/Create",
            Update = "Masters/WhatsAppTemplateVariables/Update",
            Delete = "Masters/WhatsAppTemplateVariables/Delete",
            Retrieve = "Masters/WhatsAppTemplateVariables/Retrieve",
            List = "Masters/WhatsAppTemplateVariables/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>WhatsAppTemplateVariablesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
